import { Skeleton, SkeletonRegion } from "@/components/ui/skeleton";
import CardSkeleton from "@/components/skeletons/CardSkeleton";

export default function MonthlySummarySkeleton() {
  return (
    <SkeletonRegion className="flex flex-col gap-4 sm:gap-5">
      {/* Hero */}
      <div className="rounded-[14px] border-[0.5px] border-border bg-card px-5 py-5 shadow-card sm:px-6 space-y-4">
        <Skeleton className="h-3.5 w-28" />
        <Skeleton className="h-10 w-48" />
        <div className="flex gap-2">
          <Skeleton className="h-7 w-24 rounded-full" />
          <Skeleton className="h-7 w-24 rounded-full" />
        </div>
      </div>
      <Skeleton className="h-[100px] rounded-2xl" />
      <CardSkeleton lines={2} />
      <div className="grid grid-cols-1 md:grid-cols-[1.4fr_1fr] gap-4 sm:gap-5">
        <CardSkeleton lines={4} />
        <CardSkeleton lines={4} />
      </div>
      <div className="rounded-[14px] border-[0.5px] border-border bg-card px-5 py-5 shadow-card sm:px-6 space-y-2">
        {Array.from({ length: 5 }, (_, i) => (
          <Skeleton key={i} className="h-[52px] rounded-[10px]" />
        ))}
      </div>
    </SkeletonRegion>
  );
}
